<template>
  <div>
    <service-payment-detail-header :service="service" />
    <package-service-payment-detail
      v-if="service.type === serviceType.NUM_PACKAGE_DELIVERY"
      :service="service"
    >
      <template #custom-items>
        <payment-method-item :service="service" />
      </template>
    </package-service-payment-detail>
    <parcel-service-payment-detail v-if="isParcelService" />
    <multi-point-service-payment-detail
      v-else
      :service="service"
      :service-brand="service.brand"
      :service-card="service.card"
      :service-wallet-id="service.walletId"
      :currency="serviceCity.currency"
    >
      <template #custom-items>
        <payment-method-item :service="service" />
      </template>
    </multi-point-service-payment-detail>
    <hr v-if="!isParcelService" class="m-0 mb-3" />
    <service-payment-detail-invoice
      :service="service"
      @invoice-created="$emit('reload')"
      @invoice-error="$emit('reload')"
    />
  </div>
</template>

<script>
import MultiPointServicePaymentDetail from "./MultiPointServicePaymentDetail";
import PackageServicePaymentDetail from "./PackageServicePaymentDetail";
import ParcelServicePaymentDetail from "./ParcelServicePaymentDetail";
import PaymentMethodItem from "./PaymentMethodItem";
import ServicePaymentDetailHeader from "./ServicePaymentDetailHeader";
import ServicePaymentDetailInvoice from "./ServicePaymentDetailInvoice";
import ServiceType from "@zubut/common/src/constants/services/type";

export default {
  name: "ServicePaymentDetail",

  components: {
    MultiPointServicePaymentDetail,
    PackageServicePaymentDetail,
    ParcelServicePaymentDetail,
    PaymentMethodItem,
    ServicePaymentDetailHeader,
    ServicePaymentDetailInvoice
  },

  props: {
    isBilledService: {
      type: Boolean,
      default: false
    },
    service: {
      type: Object,
      required: true
    },
    serviceBrand: {
      type: String,
      default: ""
    },
    serviceCard: {
      type: String,
      default: ""
    },
    serviceWalletId: {
      type: String,
      default: ""
    },
    serviceCity: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      serviceType: ServiceType
    };
  },

  computed: {
    isParcelService() {
      if (
        this.service.type === ServiceType.NUM_PARCEL_SEND ||
        this.service.type === ServiceType.NUM_PARCEL_RECOLLECT
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>
